"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AquiferPumping = exports.OCEAN_COST = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
var PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
var CardRenderer_1 = require("../render/CardRenderer");
exports.OCEAN_COST = 8;
var AquiferPumping = (function (_super) {
    __extends(AquiferPumping, _super);
    function AquiferPumping() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.AQUIFER_PUMPING,
            tags: [Tags_1.Tags.BUILDING],
            cost: 18,
            metadata: {
                cardNumber: '187',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 8 M€ to place 1 ocean tile. STEEL MAY BE USED as if you were playing a Building card.', function (eb) { return eb.megacredits(8).openBrackets.steel(1).closeBrackets.startAction.oceans(1); });
                }),
            },
        }) || this;
    }
    AquiferPumping.prototype.play = function () {
        return undefined;
    };
    AquiferPumping.prototype.canAct = function (player) {
        return player.canAfford(exports.OCEAN_COST, { steel: true, tr: { oceans: 1 } });
    };
    AquiferPumping.prototype.action = function (player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 8, { canUseSteel: true, title: 'Select how to pay for action', afterPay: function () {
                player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
            } }));
        return undefined;
    };
    return AquiferPumping;
}(Card_1.Card));
exports.AquiferPumping = AquiferPumping;
